import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { ReportCardItem } from "@Components/FollowUp/Report/ReportCardItem"

import { EvaluationCard } from "@Components/FollowUp/Evaluation/EvaluationCard"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { Ionicons } from "@expo/vector-icons"
import { dbDateFormat, enumerateDaysBetweenDates, getMonthAndYear } from "@Utils/utils"
import React, { useEffect, useState } from "react"
import { ScrollView, View } from "react-native"
import { Calendar } from "react-native-calendars"
import { LocaleConfig } from "react-native-calendars"
import { ChartCard } from "@Components/FollowUp/Evaluation/ChartCard"
import { useRecoilValue } from "recoil"
import { activityTypesAtom } from "@Recoil/Atom/activityAtom"
import { ActivityService } from "@Services/Activity.Service"
import SvgCourse from "@Components/CustomIcon/SvgCourse"
import SvgMusculationIcon from "@Components/CustomIcon/SvgMusculationIcon"
import SvgAviron from "@Components/CustomIcon/SvgAviron"
import moment from "moment"
import { userAtom } from "@Recoil/Atom/userAtom"
import { CustomBarChart } from "./CustomBarChart"
import { ActivityIndicator } from "react-native-paper"

LocaleConfig.locales["fr"] = {
    monthNames: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
    ],
    monthNamesShort: [
        "Janv.",
        "Févr.",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juil.",
        "Août",
        "Sept.",
        "Oct.",
        "Nov.",
        "Déc."
    ],
    dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    dayNamesShort: ["D", "L", "M", "M", "J", "V", "S"],
    today: "Aujourd'hui"
}
LocaleConfig.defaultLocale = "fr"

const renderArrow = (direction) => {
    return (
        <Ionicons
            color={baseColors.green.primary}
            name={direction == "right" ? "chevron-forward" : "chevron-back"}
            size={20}
        />
    )
}

const renderHeader = (date) => {
    return (
        <View>
            <OpenSansText color={baseColors.green.primary}>{getMonthAndYear(date)}</OpenSansText>
        </View>
    )
}

const renderDay = ({ date, state }) => {
    return (
        <View>
            <OpenSansText
                style={{ textAlign: "center", color: state === "disabled" ? "white" : baseColors.green.primary }}
            >
                {date.day}
            </OpenSansText>
        </View>
    )
}

export const ToolboxFollowUp = ({ navigation }) => {
    const _format = "YYYY-MM-DD"
    const _today = moment().format(_format)
    const activityTypes = useRecoilValue(activityTypesAtom)
    const [marked, setMarked] = useState({})
    const reports = ["28/11/2020", "15/09/2020", "28/06/2020"]
    const user = useRecoilValue(userAtom)
    const [activityRenforcementCount, setActivityRenforcementCount] = useState(0)
    const [activityEnduranceCount, setActivityEnduranceCount] = useState(0)
    const [activityHour, setActivityHour] = useState(0)
    const [activityRate, setActivityRate] = useState(0)
    const [activityDetailsDistance, setActivityDetailsDistance] = useState(null)
    const [activityDetailsDuration, setActivityDetailsDuration] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [loadingDistance, setLoadingDistance] = useState(false)
    const [loadingDuration, setLoadingDuration] = useState(false)

    const onDaySelect = (day) => {
        const _selectedDay = moment(day.dateString).format(_format)
        setMarked({})
        let selected = true
        if (marked[_selectedDay]) {
            // Already in marked dates, so reverse current marked state
            selected = !marked[_selectedDay].selected
        }

        // Create a new object using object property spread since it should be immutable
        // Reading: https://davidwalsh.name/merge-objects
        let updatedMarkedDates = {
            ...marked,
            ...{
                [_selectedDay]: {
                    marked: selected,
                    selected: selected,
                    selectedColor: baseColors.green.pastel,
                    dotColor: baseColors.green.pastel,
                    color: baseColors.green.pastel,
                    textColor: "white"
                }
            }
        }

        if (!selected) {
            Object.keys(updatedMarkedDates).forEach((k) => {
                if (
                    moment(k, _format).toDate() > moment(day.dateString, _format).toDate() ||
                    !updatedMarkedDates[k].marked
                ) {
                    delete updatedMarkedDates[k]
                }
            })
        }

        if (Object.keys(updatedMarkedDates).length > 0) {
            let listDate = Object.keys(updatedMarkedDates)
                .map((k) => {
                    return moment(k, _format).toDate()
                })
                .sort((a, b) => a - b)
            listDate = enumerateDaysBetweenDates(listDate[0], listDate[listDate.length - 1])

            const startD = listDate[0]
            const endD = listDate[listDate.length - 1]

            setStartDate(startD)
            setEndDate(endD)
            updatedMarkedDates = {}
            for (let i = 0; i < listDate.length; i++) {
                const formatedDate = moment(listDate[i]).format(_format)
                if (i === 0) {
                    updatedMarkedDates[formatedDate] = {
                        marked: true,
                        selected: true,
                        selectedColor: baseColors.green.pastel,
                        dotColor: baseColors.green.pastel,
                        color: baseColors.green.pastel,
                        textColor: "white",
                        startingDay: true
                    }
                } else if (i === listDate.length - 1) {
                    updatedMarkedDates[formatedDate] = {
                        marked: true,
                        selected: true,
                        selectedColor: baseColors.green.pastel,
                        dotColor: baseColors.green.pastel,
                        color: baseColors.green.pastel,
                        textColor: "white",
                        endingDay: true
                    }
                } else {
                    updatedMarkedDates[formatedDate] = {
                        marked: true,
                        selected: true,
                        selectedColor: baseColors.green.pastel,
                        dotColor: baseColors.green.pastel,
                        color: baseColors.green.pastel,
                        textColor: "white"
                    }
                }
            }
        } else {
            setStartDate(null)
            setEndDate(null)
        }
        setMarked({ ...updatedMarkedDates })
    }
    const fetchDistance = () => {
        setLoadingDistance(true)
        ActivityService.getActivityDetailsDistance(
            user.id,
            startDate ? moment(startDate, dbDateFormat).format(dbDateFormat) : startDate,
            endDate ? moment(endDate, dbDateFormat).format(dbDateFormat) : endDate
        )
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    setActivityDetailsDistance(parseDataToChart(data))
                }
                setLoadingDistance(false)
            })
            .catch((e) => {
                setLoadingDistance(false)
            })
    }
    const fetchDuration = () => {
        setLoadingDuration(true)
        ActivityService.getActivityDetailsDuration(
            user.id,
            startDate ? moment(startDate, dbDateFormat).format(dbDateFormat) : startDate,
            endDate ? moment(endDate, dbDateFormat).format(dbDateFormat) : endDate
        )
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    setActivityDetailsDuration(parseDataToChart(data))
                }
                setLoadingDuration(false)
            })
            .catch((e) => {
                setLoadingDuration(false)
            })
    }

    const parseDataToChart = (brutData) => {
        const { categories, data } = brutData
        const series = []

        if (categories?.length > 0 && data?.length > 0) {
            for (let i = 0; i < categories.length; i++) {
                series.push({ date: categories[i].substr(8, 10), value: data[i] })
            }
        }
        return series.splice(0, 12)
    }

    useEffect(() => {
        fetchDistance()
        fetchDuration()
    }, [startDate, endDate])

    const NoChartData = (props) => (
        <View
            style={{
                flex: 1,
                backgroundColor: baseColors.green.light,
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                padding: 30,
                borderRadius: 8
            }}
        >
            <OpenSansText fontSize={16} color={baseColors.green.primary}>
                {`Aucune donnée ${props.valueType} disponible.`}
            </OpenSansText>
        </View>
    )
    return (
        <ContainerStackScreen style={{ paddingHorizontal: 0 }}>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                <Calendar
                    theme={{
                        dayTextColor: baseColors.green.primary,
                        selectedDayBackgroundColor: baseColors.green.primary,
                        selectedDayTextColor: baseColors.white
                    }}
                    onDayPress={(d) => onDaySelect(d)}
                    markedDates={marked}
                    markingType={"period"}
                    //dayComponent={renderDay}
                    //renderHeader={renderHeader}
                    renderArrow={renderArrow}
                />

                <Spacer height={30} />

                {/* <ChartCard /> */}

                {loadingDistance ? (
                    <ActivityIndicator style={{ margin: 20 }} color={baseColors.green.primary} size={"large"} />
                ) : activityDetailsDistance?.length > 0 ? (
                    <CustomBarChart
                        valueType={"Distance (km)"}
                        title={"Endurance"}
                        loading={loadingDistance}
                        data={activityDetailsDistance}
                    />
                ) : (
                    <NoChartData valueType={"d'endurance"} />
                )}

                <Spacer height={30} />

                {loadingDuration ? (
                    <ActivityIndicator style={{ margin: 20 }} color={baseColors.green.primary} size={"large"} />
                ) : activityDetailsDuration?.length > 0 ? (
                    <CustomBarChart
                        valueType="Durée (min)"
                        title="Résistance"
                        loading={loadingDuration}
                        data={activityDetailsDuration}
                    />
                ) : (
                    <NoChartData valueType="de résistance" />
                )}

                <Spacer height={20} />

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <EvaluationCard
                        startDate={startDate}
                        endDate={endDate}
                        callback={ActivityService.getActivityRate}
                        icon={<Ionicons color={baseColors.white} size={30} name="md-checkmark" />}
                        backgroundColor={baseColors.green.primary}
                        description="taux de validation total"
                    />
                    <EvaluationCard
                        startDate={startDate}
                        endDate={endDate}
                        icon={<Ionicons color={baseColors.white} size={30} name="stopwatch" />}
                        backgroundColor={baseColors.orange.primary}
                        callback={ActivityService.getActivityHour}
                        description="heures d'activité au total"
                    />
                </View>

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <EvaluationCard
                        startDate={startDate}
                        endDate={endDate}
                        icon={<SvgCourse color={baseColors.white} />}
                        backgroundColor={baseColors.green.primary}
                        description={"activités d'endurance"}
                        callback={ActivityService.getActivityEnduranceCount}
                    />
                    <EvaluationCard
                        startDate={startDate}
                        endDate={endDate}
                        icon={<SvgAviron color={baseColors.white} />}
                        backgroundColor={baseColors.green.primary}
                        description={"activités de renforcement"}
                        callback={ActivityService.getActivityRenforcementCount}
                    />
                </View>

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <EvaluationCard
                        startDate={startDate}
                        endDate={endDate}
                        icon={<SvgCourse color={baseColors.white} />}
                        backgroundColor={baseColors.orange.primary}
                        description={"durée d'endurance"}
                        callback={ActivityService.getActivityEnduranceHour}
                    />
                    <EvaluationCard
                        startDate={startDate}
                        endDate={endDate}
                        icon={<SvgAviron color={baseColors.white} />}
                        backgroundColor={baseColors.green.primary}
                        description={"durée de renforcement"}
                        callback={ActivityService.getActivityRenforcementHour}
                    />
                </View>
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
